import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/mspr/service-providers')({
    staticData: {
        metadata: {
            title: 'Service providers',
        },
    },
    component: Outlet,
});
